<template>
  <div>
    <el-dialog :visible.sync="dialogVisible" title="图片预览">
      <section class="imgPreiewBox">
        <img width="100%" :src="dialogImageUrl" alt />
      </section>
    </el-dialog>
    <qx-card title="车辆费用" class="detail" v-loading="loading">
      <!-- 订单详情数据 -->
      <!-- 费用申请 -->
      <qx-detail-box :data="detailData.base">
        <span slot="payAmt" slot-scope="prop">{{ prop.data.payAmt }}元</span>
      </qx-detail-box>
      <!-- 事故信息 -->
      <qx-detail-box
        v-show="detailData.base.tableData.data.costType === 2009"
        :data="detailData.accident"
      />
      <!-- 明细信息 -->
      <qx-card-inline title="明细信息">
        <span slot="title-left" class="detail-title">申请金额：{{originData.payAmt}}元</span>
        <section class="detailOtherInfo">
          <el-table class="tableBox" :data="originData.costDetails" tooltip-effect="dark">
            <!-- 常规列表项 -->
            <el-table-column
              v-for="(item, index, key) in tableTitle"
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :min-width="item.minW"
              :width="item.w"
            ></el-table-column>
          </el-table>
          <!-- <p class="line">费用说明：{{ originData.feeRemark }}</p> -->
          <p v-if="originData.picList && originData.picList.length !== 0">
            上传附件：
            <img
              class="cur"
              v-for="item in originData.picList"
              :src="item.fileUrl"
              :key="item.fileUrl"
              @click="previewImg(item.fileUrl)"
            />
          </p>
        </section>
      </qx-card-inline>
      <!-- 收款信息 -->
      <qx-detail-box :data="detailData.receipt" />
      <!-- 订单详情数据 end -->
    </qx-card>
    <ApproveBox
      v-if="(type ||$route.query.type) === 'approve'"
      :busiId="id ? String(id) : $route.query.id"
      busiCode="22000050"
      :inFast="Boolean(id)"
      :stayInCurrentPage="true"
    />
  </div>
</template>

<script>
import {
  carCostDetail, // 获取详情
  carCostApprove,
} from 'api/cost';
import {
  getBigImg,
} from '@qx/utils';
import ApproveBox from 'components/approveBox';
export default {
  components: {
    ApproveBox,
  },
  props: {
    id: {
      type: Number,
    },
    type: {
      type: String,
    },
  },
  data () {
    return {
      loading: false,
      dialogVisible: false,
      dialogImageUrl: '',
      originData: {},
      oilTableTitle: [ // 加油费
        { prop: 'plateNumber', label: '车牌号码' },
        { prop: 'orderId', label: '订单号码' },
        { prop: 'oilLitre', label: '加油升数（L）' },
        { prop: 'payAmt', label: '加油费（元）' },
        { prop: 'payRemark', label: '费用说明' },
      ],
      tollTableTitle: [ // 过路费
        { prop: 'plateNumber', label: '车牌号码' },
        { prop: 'orderId', label: '订单号码' },
        { prop: 'line', label: '线路' },
        { prop: 'payAmt', label: '过路费（元）' },
        { prop: 'payRemark', label: '费用说明' },
      ],
      parkingFeeTableTitle: [ // 停车费
        { prop: 'plateNumber', label: '车牌号码' },
        { prop: 'licenceTypeName', label: '牌照类型' },
        // { prop: 'orderId', label: '订单号码' },
        // { prop: 'parkTime', label: '停车时间' },
        // { prop: 'parkLen', label: '停车时长（小时）' },
        // { prop: 'parkPrice', label: '停车单价（元）' },
        { prop: 'payAmt', label: '停车费（元）' },
        { prop: 'payRemark', label: '费用说明' },
      ],
      annualReviewTableTitle: [ // 年审费
        { prop: 'plateNumber', label: '车牌号码' },
        { prop: 'licenceTypeName', label: '牌照类型' },
        { prop: 'certificatesInsuranceTypeName', label: '年审类型' },
        { prop: 'insuranceStartDate', label: '年审日期' },
        { prop: 'insuranceEndDate', label: '截止有效日期' },
        { prop: 'payAmt', label: '年审费用（元）' },
      ],
      insuranceTableTitle: [ // 保险费
        { prop: 'plateNumber', label: '车牌号码' },
        { prop: 'licenceTypeName', label: '牌照类型' },
        { prop: 'certificatesInsuranceTypeName', label: '保险类型' },
        { prop: 'agentCompany', label: '被保险人' },
        { prop: 'insuranceStartDate', label: '起保日期' },
        { prop: 'insuranceEndDate', label: '终保日期' },
        { prop: 'payAmt', label: '保费（元）' },
        { prop: 'payRemark', label: '费用说明' },
      ],
      violationTableTitle: [ // 违章费
        { prop: 'plateNumber', label: '车牌号码' },
        { prop: 'categoryIdName', label: '违章类型' },
        { prop: 'violationTime', label: '违章时间' },
        { prop: 'locationName', label: '违章城市' },
        { prop: 'violationAddress', label: '违章地点' },
        { prop: 'violationCode', label: '违章代码' },
        { prop: 'violationFine', label: '罚金' },
        { prop: 'overdueFine', label: '滞纳金' },
        { prop: 'violationPoint', label: '扣分数' },
        { prop: 'violationReason', label: '违章行为' },
        { prop: 'personLiable', label: '责任人' },
        { prop: 'otherFee', label: '代办处理费' },
        { prop: 'payAmt', label: '申请金额', slot: true },
      ],
      gpsTableTitle: [ // gps
        { prop: 'plateNumber', label: '车牌号码' },
        { prop: 'equipmentNumber', label: '设备号' },
        { prop: 'serviveLoseDate', label: '服务失效日期', w: 110 },
        { prop: 'suitTypeName', label: '套装类型' },
        // { prop: 'oilWearEquoipmentBrand', label: '油耗设备品牌' },
        // { prop: 'gpsEquoipmentBrand', label: '定位设备品牌' },
        // { prop: 'oilWearEquoipmentModel', label: '油耗设备型号' },
        // { prop: 'gpsEquoipmentModel', label: '定位设备型号' },
        // { prop: 'oilWearEquoipmentNumber', label: '油耗设备号' },
        // { prop: 'gpsEquoipmentNumber', label: '定位设备号' },
        { prop: 'suitFee', label: '套装费用' },
      ],
      accidentTableTitle: [ // 事故
        { prop: 'lossTypeName', label: '损失类型' },
        { prop: 'payAmt', label: '理赔金额（元）' },
        { prop: 'payRemark', label: '费用说明' },
      ],
      maintenanceTableTitle: [ // 维修保养
        { prop: 'plateNumber', label: '车牌号码' },
        { prop: 'licenceTypeName', label: '牌照类型' },
        { prop: 'feeAscriptionDate', label: '维修日期' },
        { prop: 'payAmt', label: '维修费用' },
        { prop: 'serviceName', label: '服务商' },
        { prop: 'productName', label: '维修网点' },
        { prop: 'repairReson', label: '维修内容' },
        // { prop: 'detailPic', label: '附件' },
      ],
      otherTableTitle: [ // 其他车辆费
        { prop: 'plateNumber', label: '车牌号码' },
        { prop: 'licenceTypeName', label: '牌照类型' },
        { prop: 'feeAscriptionDate', label: '费用日期' },
        { prop: 'payAmt', label: '费用金额' },
        { prop: 'payRemark', label: '费用说明' },
      ],
      ureaTableTitle: [ // 尿素
        { prop: 'plateNumber', label: '车牌号码' },
        { prop: 'ureaTypeName', label: '产品类型' },
        { prop: 'ureaSpecifications', label: '规格（L）' },
        { prop: 'ureaCount', label: '数量' },
        { prop: 'ureaPriceStr', label: '单价（元）' },
        { prop: 'payAmt', label: '申请金额（元）' },
      ],
      rentTableTitle: [ // 车辆租金
        { prop: 'plateNumber', label: '车牌号码' },
        { prop: 'trailerNumber', label: '挂车车牌' },
        { prop: 'tenancyStartDate', label: '租期开始时间' },
        { prop: 'tenancyEndDate', label: '租期结束时间' },
        { prop: 'payAmt', label: '申请金额（元）' },
        { prop: 'payRemark', label: '费用说明' },
      ],
      infoTableTitle: [ // 信息费
        { prop: 'plateNumber', label: '车牌号码' },
        { prop: 'orderId', label: '订单号码' },
        { prop: 'payAmt', label: '申请金额（元）' },
        { prop: 'payRemark', label: '费用说明' },
      ],
      shroudTableTitle: [ // 导流罩
        { prop: 'plateNumber', label: '车牌号码' },
        { prop: 'installDate', label: '安装时间' },
        { prop: 'purchaseFee', label: '采购原价' },
        { prop: 'payAmt', label: '申请金额（元）' },
      ],
      detailData: {
        base: {
          label: '费用申请',
          tableData: {
            title: [
              { prop: 'costTypeName', label: '费用类型' },
              { prop: 'orgName', label: '费用归属' },
              { prop: 'isNeedBillName', label: '是否开票' },
              { prop: 'serviceName', label: '服务商' },
              // { prop: 'payAmt', label: '申请金额', slot: true },
              // { prop: 'feeAscriptionDate', label: '费用归属日期' },
              // { prop: 'plateNumber', label: '车牌号' },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
        accident: {
          label: '事故信息',
          hide: false,
          tableData: {
            title: [
              { prop: 'plateNumber', label: '车牌号码' },
              { prop: 'insuranceCompany', label: '保险公司' },
              { prop: 'insuranceUserName', label: '被保险人' },
              { prop: 'insuranceStartDate', label: '起保日期' },
              { prop: 'insuranceEndDate', label: '终保日期' },
              { prop: 'insuranceNumber', label: '保单号' },
              { prop: 'accidentTime', label: '出险日期' },
              { prop: 'reportTime', label: '报案日期' },
              { prop: 'responsibilityAttributionName', label: '责任归属' },
              { prop: 'isVehicleDamageName', label: '是否本车车损' },
              { prop: 'isOtherAccidentName', label: '是否对方车损' },
              { prop: 'isGoodsDamageName', label: '是否物损' },
              { prop: 'isRoadDamageName', label: '是否道路损' },
              { prop: 'isWoundingName', label: '人伤标志' },
              { prop: 'repairServiceName', label: '维修服务商' },
              { prop: 'repairServiceAmt', label: '维修金额' },
              { prop: 'repairServiceAddress', label: '维修地点' },
              { prop: 'repairServiceTel', label: '联系方式' },
              { prop: 'isRepairCompleteName', label: '是否完结' },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
        receipt: {
          label: '收款信息',
          tableData: {
            title: [
              { prop: 'receName', label: '收款方名称' },
              { prop: 'receUserName', label: '收款账户名' },
              { prop: 'receBankName', label: '收款银行' },
              { prop: 'receBankNo', label: '收款账号' },
              { prop: 'receUserTypeName', label: '收款人类型' },
              // { prop: 'deductAmount', label: '抵扣借支', unit: '元' },
              { prop: 'shouldPayAmount', label: '应付金额', unit: '元' },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
      },
    };
  },
  computed: {
    colSpan () {
      const total = 24;
      const minSpan = 4;
      return parseInt(total / this.orderInfo.length, 10) < minSpan ? minSpan : parseInt(total / this.orderInfo.length, 10);
    },
    tableTitle () {
      switch (Number(this.originData.costType)) {
        case 3001: // 加油费
          return this.oilTableTitle;
        case 3007: // 过路费
          return this.tollTableTitle;
        case 2010: // 停车费
          return this.parkingFeeTableTitle;
        case 2005: // 年审费
          return this.annualReviewTableTitle;
        case 2006: // 保险费
          return this.insuranceTableTitle;
        case 2008: // 违章费
          return this.violationTableTitle;
        case 2009: // 事故
          return this.accidentTableTitle;
        case 2020: // 维修保养
          return this.maintenanceTableTitle;
        case 2022: // 其他车辆费
          return this.otherTableTitle;
        case 4015: // gps
          return this.gpsTableTitle;
        case 2012: // 尿素
          return this.ureaTableTitle;
        case 2002: // 车辆租金
          return this.rentTableTitle;
        case 4021: // 信息费
        case 4019: // 信息费
          return this.infoTableTitle;
        case 4016: // 导流罩
          return this.shroudTableTitle;
        default:
          return [];
      }
    },
  },
  watch: {
    '$route.query.id': function () {
      this.getData();
    },
  },
  methods: {
    previewImg (url) {
      this.dialogVisible = true;
      this.dialogImageUrl = getBigImg(url);
    },
    async getData () {
      if (this.$route.path !== '/manage/cost/car/car/feeApplyDetail' && !this.id) {
        return;
      }
      this.loading = true;
      const detailRes = await carCostDetail({
        payId: this.id || this.$route.query.id,
        isEdit: 2,
      });
      this.loading = false;
      if (!detailRes.failed) {
        if (detailRes.costType !== 2009) {
          this.detailData.accident.hide = true;
        } else {
          this.detailData.accident.tableData.data = detailRes.costDetails[detailRes.costDetails.length - 1]; // 事故信息
        }
        detailRes.shouldPayAmount = (detailRes.shouldPayAmount / 100).toFixed(2);
        detailRes.feeAscriptionDate = this.formatDate(detailRes.feeAscriptionDate);

        if (detailRes.costDetails && detailRes.costDetails.length) {
          for (let item of detailRes.costDetails) {
            item.serviveLoseDate = this.formatDate(item.serviveLoseDate);
          }
        }

        detailRes.isBeyond = true;
        if (detailRes.sumBudget === null || detailRes.sumBudget === undefined) {
          detailRes.noBudget = true;
          detailRes.exceed = false;
        } else {
          // 有预算额度
          detailRes.noBudget = false;
          let amt = detailRes.payAmt ? Number(detailRes.payAmt) : 0;
          let total = detailRes.sumBudget ? (detailRes.sumBudget / 100).toFixed(2) : 0;
          let remainAmt = detailRes.sumBudgetBalance ? (detailRes.sumBudgetBalance / 100).toFixed(2) : 0;
          detailRes.budget = remainAmt;
          detailRes.tempBudget = Number(total);
          if (amt - Number(remainAmt) > 0) {
            detailRes.exceed = true;
            detailRes.finalBudget = (amt - Number(remainAmt)).toFixed(2);
          } else {
            detailRes.exceed = false;
          }
        }
        this.originData = detailRes;
        this.detailData.base.tableData.data = detailRes; // 费用申请
        this.detailData.receipt.tableData.data = detailRes; // 收款信息
      }
    },
    async approve (formData) {
      const res = await carCostApprove(formData);
      if (!res.failed) {
        this.$message({
          type: 'success',
          message: '审核成功',
        });
      }
    },
  },
  created () {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
@import 'styles/config.scss';
.tableBox {
  margin-bottom: 16px;
}
.detailOtherInfo {
  padding: 0 24px;
  .line {
    margin-bottom: 16px;
  }
  img {
    width: 80px;
    height: 80px;
    margin-right: 16px;
    margin-bottom: 16px;
  }
}
.imgPreiewBox {
  padding-bottom: 24px;
}
.detail-title {
  font-size: 14px;
  color: #555;
  margin-left: 16px;
}
</style>
